var _circle, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSoundOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 26.5,
    fill: "url(#paint0_linear_28_124)",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 19.5V34.5C27 35.325 26.421 35.6527 25.7137 35.2282L20.7863 32.2717C20.079 31.8472 18.825 31.5 18 31.5H17.25C16.425 31.5 15.75 30.825 15.75 30V24C15.75 23.175 16.425 22.5 17.25 22.5H18C18.825 22.5 20.079 22.1527 20.7863 21.7282L25.7137 18.7717C26.421 18.3472 27 18.675 27 19.5ZM35.121 27L37.0605 25.0605C37.6462 24.4747 37.6462 23.5252 37.0605 22.9395C36.4748 22.3537 35.5252 22.3537 34.9395 22.9395L33 24.879L31.0605 22.9395C30.4747 22.3537 29.5253 22.3537 28.9395 22.9395C28.3538 23.5252 28.3538 24.4747 28.9395 25.0605L30.879 27L28.9395 28.9395C28.3538 29.5252 28.3538 30.4747 28.9395 31.0605C29.2327 31.3537 29.616 31.5 30 31.5C30.384 31.5 30.7673 31.3537 31.0605 31.0605L33 29.121L34.9395 31.0605C35.2327 31.3537 35.616 31.5 36 31.5C36.384 31.5 36.7673 31.3537 37.0605 31.0605C37.6462 30.4747 37.6462 29.5252 37.0605 28.9395L35.121 27Z",
    fill: "#535789"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_28_124",
    x1: 7.5,
    y1: 13,
    x2: 46.5,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2C2C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2C2C9",
    stopOpacity: 0.2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundOff);
export default __webpack_public_path__ + "static/media/soundOff.47764e75b442963492d587dda1bd96d2.svg";
export { ForwardRef as ReactComponent };